import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MainService } from 'app/resources/services/index';

@Component({
  selector: 'app-detalhe',
  templateUrl: './detalhe.component.html',
  styleUrls: ['./detalhe.component.css']
})
export class DetalheComponent implements OnInit {

  public processando: boolean;
  public mensagem: any;

  constructor(public mainService: MainService, public router: Router) { }

  ngOnInit() {
    this.processando = false;
    this.mensagem = { mensagem: '' };
    this.mainService.saldoService.initialize();

  }

  public saveMensagem() {

    this.processando = true;

    const url = 'cartao/current/chamado/' + this.mainService.sacService.chamadoSelecionado.id
      + '/' + this.mainService.sacService.chamadoSelecionado.uuid + '/mensagem/';
    this.mainService.http.pathRest().post(url, { mensagem: this.mensagem }, true)
      .subscribe(
      sucesso => {
        this.processando = false;
        this.mainService.sacService.visualizarChamado(this.mainService.sacService.chamadoSelecionado);
      }
      );
  };

  public finalizeChamado() {

    const url = 'chamado/' + this.mainService.sacService.chamadoSelecionado.id
      + '/' + this.mainService.sacService.chamadoSelecionado.uuid + '/status/solucionado/nota/'
      + this.mainService.sacService.chamadoSelecionado.nota + '/';

    this.mainService.http.pathRest().put(url, this.mainService.sacService.chamadoSelecionado.status = 'solucionado', true)
      .subscribe(
      sucesso => {
      });
  };

}



// WEBPACK FOOTER //
// ./src/app/menu-superior/sac/detalhe/detalhe.component.ts